<div class="notifications-panel ct-card">
  <div class="panel-header">
    <h5>{{ 'company-tool.topnav.notifications.title' | transloco }}</h5>
    <div class="panel-actions">
      <app-button
        variant="ghost"
        [iconStart]="fontawesomeService.light.eye"
        [ariaLabel]="
          ('company-tool.topnav.notifications.seen-all-tooltip' | transloco)
        "
        (click)="markAllNotificationsAsSeen()"
      ></app-button>
      <app-button
        variant="ghost"
        [iconStart]="fontawesomeService.light.times"
        [ariaLabel]="('company-tool.topnav.close-tooltip' | transloco)"
        (click)="dismissPopover($event)"
      ></app-button>
    </div>
  </div>
  <div
    class="notifications-scroll"
    [class.no-notifications]="
      ((notifications$ | async)?.length ?? 0) === 0 &&
      !(notificationsLoading$ | async)
    "
    scrollEndRoot
  >
    <app-notifications
      (notificationNavigate)="dismissPopover()"
    ></app-notifications>
    <div
      (scrollEnd)="loadMoreNotifications()"
      rootMargin="0px 0px 250px 0px"
    ></div>
    @if (notificationsLoading$ | async) {
      <div class="loader">
        <ct-lib-spinner></ct-lib-spinner>
      </div>
    }
  </div>
</div>
